const fonts = {
    heading: { value: "canada-type-gibson, Arial" },
    body: { value: "canada-type-gibson, Arial" },
}

export default fonts
